import Table from "../../Table/Table";
import classes from "../../Table/Table.module.css";
import axios from "axios";
import { useContext, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import authContext from "../../../../AuthContext/authContext";
import appActions from "../../../../ReduxStore/appDataSlice";
import { useEffect } from "react";
import { toast } from "react-toastify";
import Home from "../../Common/Home/Home";
import ConfirmModal from "../../Common/ConfirmModal/ConfirmModal";
const base_url = process.env.REACT_APP_BASE_URL;
const GuardWrapper = () => {
  const activeCompany = useSelector((state) => state.appData.activeCompany);
  const activeLocation = useSelector((state) => state.appData.activeLocation);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const ctx = useContext(authContext);
  const userType = ctx.userData.user_type;
  const userRole = 'Guard';
  const token = ctx.token;
  const [employeeDirectory, setShowEmployeeDirectory] = useState(false);
  const [isLoading, setIsloading] = useState(false);
  const [locationToDelete, setLocationToDelete] = useState({});

  const handleEdit = (id) => {
    dispatch(appActions.setActiveEditEmployeeId(id));
    localStorage.setItem("activeEditEmployeeId", id);
    dispatch(appActions.setActiveEditType("Guard"));
    localStorage.setItem("activeEditType", "Guard");
    navigate("/guard/editGuard");
  };

  const handleDelete = async (id) => {
    try {
      await axios({
        method: "DELETE",
        url: `${base_url}/user/locationManager/${id}`,
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });
      toast.success("Guard deleted successfully");
    } catch (error) {
      console.error("Failed to delete guard:", error);
      toast.error(error.response?.data?.message || "Failed to delete guard");
    }
  };

  useEffect(() => {
    setIsloading(true);
    let reqObj = {
      method: "GET",
      url: `${base_url}/company/details/${activeCompany._id}`,
      headers: {
        "Content-Type": "application/javascript",
        Authorization: `Bearer ${token}`,
      },
    };

    axios(reqObj)
      .then((res) => {
        setShowEmployeeDirectory(res.data.employeeDirectory);
        setIsloading(false);
      })
      .catch((err) => {
        console.log(err);
        setIsloading(false);
      });
  }, []);

  const columns = [
    {
      name: "S. No.",
      cell: (row, index) => index + 1,
    },
    {
      name: "Manager Name",
      selector: (row) => row.name,
      sortable: true,
    },
    {
      name: "Email",
      selector: (row) => row.email,
      sortable: true,
    },
    {
      name: "Phone",
      selector: (row) => row.phone,
      sortable: true,
    },
    {
      name: "Location",
      selector: (row) => row.location,
      sortable: true,
    },
    {
      name: "Action",
      cell: (row) => (
        <>
          <div className={classes.icons}>
            {/* <img src={require("../../../../assets/img/admin-images/eye.png")} /> */}
            <img
              style={{ cursor: "pointer" }}
              src={require("../../../../assets/img/admin-images/edit_thin.png")}
              onClick={() => handleEdit(row._id)}
            />
            <img
              style={{ cursor: "pointer" }}
              data-bs-toggle="modal"
              data-bs-target="#exampleModal"
              src={require("../../../../assets/img/admin-images/delete.png")}
              // onClick={() => handleDelete(row._id)}
              onClick={() =>
                setLocationToDelete({ id: row._id, location: row.location })
              }
            />
          </div>
        </>
      ),
    },
  ];

  let showAddNew = true;
  let showCsvExport = false;
  let showDownload = false;
  let showExport = false;
  let showLocation = true;
  let showSms = true;
  let showFirstHr = false;
  let showSecondHr = true;
  let showActions = true;
  let showVisitor = true;

  if(userType === "location"){
    showLocation = false;
  }

  if (userType === "Company Manager") {
    showAddNew = true;
    showCsvExport = false;
    showDownload = false;
    showExport = false;
    showLocation = true;
    showSms = false;
    showFirstHr = false;
    showSecondHr = false;
    showActions = false;
    showVisitor = false;
  }
  if (userType === "guard") {
    showAddNew = true;
    showCsvExport = false;
    showDownload = false;
    showExport = false;
    showLocation = false;
    showSms = false;
    showFirstHr = false;
    showSecondHr = false;
    showActions = false;
    showVisitor = false;
  }

  const options = {
    // title: activeCompany.name,
    title: "Guard",
    showCsvExport: showCsvExport,
    showDownload: showDownload,
    showExport: showExport,
    showLocation: showLocation,
    showSms: showSms,
    showAddNew: showAddNew,
    showFirstHr: showFirstHr,
    showSecondHr: showSecondHr,
    showActions: showActions,
    type: "Guard",
    columns: columns,
    apiUrl: `${base_url}/auth/guard/list`,
    companyId: activeCompany._id,
    showVisitor: showVisitor,
    employeeDirectorySwitch: employeeDirectory,
  };
  return (
    <>
      <Home propComponent={<Table options={options} isLoading={isLoading} />} />
      <ConfirmModal
        handleDelete={handleDelete}
        id={locationToDelete.id}
        msg={`Are you sure you want to delete ${locationToDelete.location} guard?`}
      />
    </>
  );
};

export default GuardWrapper;
